"use client";

import { m } from "framer-motion";
import type { ComponentPropsWithoutRef, ElementType, ReactNode } from "react";
import { landingViewport, slideUp } from "@/lib/landing-motion";

type MotionTag = keyof typeof m;

type LandingRevealProps<T extends MotionTag = "div"> = {
    as?: T;
    children: ReactNode;
    custom?: number;
    className?: string;
    mode?: "inView" | "enter";
    viewport?: ComponentPropsWithoutRef<typeof m.div>["viewport"];
} & Omit<ComponentPropsWithoutRef<"div">, "children">;

export function LandingReveal<T extends MotionTag = "div">({
    as,
    children,
    custom = 0,
    className,
    mode = "inView",
    viewport = landingViewport,
    ...rest
}: LandingRevealProps<T>) {
    const Comp = (as ? m[as] : m.div) as ElementType;

    return (
        <Comp
            variants={slideUp}
            custom={custom}
            initial="hidden"
            {...(mode === "enter"
                ? { animate: "visible" as const }
                : { whileInView: "visible" as const, viewport })}
            className={className}
            {...rest}
        >
            {children}
        </Comp>
    );
}
